<div class="card">
    <div class="card__title">
        <div>{{ 'lta-event-sets.status' | translate }}</div>
        <lta-svg-icon
                class="remove-btn"
                icon="close"
                size="20"
                (click)="onDelete.emit()"
                *ngIf="!readonly"
        />
    </div>
    <div class="card__body" [formGroup]="statusForm">
        <lta-select
                *ngIf="modelType == 2"
                [selectOptions]="boolValueOptions"
                [control]="statusForm.get('value')"
                formControlName="value"
                label="{{ 'lta-event-sets.eventValue' | translate }}"
                theme="white"
        />
        <lta-input
                *ngIf="modelType == 3"
                [control]="statusForm.get('value')"
                label="{{ 'lta-event-sets.eventValue' | translate }}"
                formControlName="value"
                theme="white"
                type="number"
        />
        <lta-select
                [selectOptions]="eventClassesOptions"
                formControlName="eventClass"
                label="{{ 'lta-event-sets.eventClass' | translate }}"
                theme="white"
        />
        <lta-input
                label="{{ 'lta-event-sets.eventText' | translate }}"
                formControlName="eventText"
                theme="white"
        />
    </div>
</div>
